import { Toast } from 'primereact';
import React, { useContext, useEffect, useRef, useState } from 'react'



import Card from '../../../Base/Components/Card/Card';
import { toastShow } from '../../../Base/Services/ToastService';
import AgGrid from '../../../Base/Components/Tables/AgGrid/AgGrid';
import CalendarWeek from '../../../Base/Components/Form/CalendarWeek';
import { getDatesProduccion } from '../../../Base/Services/Moment/Luxon';


import { autUsoHilaza, getListAutorizacionUsoHilaza } from '../../../API/Planning/AutorizacionUsoHilaza';
import { AuthContext } from '../../../Base/Context/AuthContext/AuthContext';

const AutorizacionUsoHilazaScreen = () => {

    const toast = useRef(null);

    const { userAuth } = useContext(AuthContext);

    const [list, setList] = useState([]);
    const [dates, setDates] = useState([new Date(), new Date()]);
    const [loading, setLoading] = useState(false);
    const [select, setSelect] = useState([]);


    const getInfo = async () => {
        setLoading(true);
        const d = getDatesProduccion(dates)
        const t = await getListAutorizacionUsoHilaza(d);
        setList(t);
        setLoading(false);
    }


    const changePermiso = async(e, rowData, funcion) => {
       if(select.length > 0){

       }else{
        const t = await autUsoHilaza({
            Funcion: funcion,
            IdCheck: rowData.data.Id + ''
        })
        toastShow(toast, 'success', 'Permisos actualizados');
        getInfo()
       }
    }

    const columns = [
        {
            header: 'Fecha',
            field: 'FechaCreacion',
            className: 'medium'
        },
        {
            header: 'Estados',
            field: 'Estados',
            className: 'Xsmall'
        },
        
        {
            header: 'Cliente',
            field: 'Cliente',
        },
        {
            header: 'Hilaza',
            field: 'Hilaza',
        },
        {
            header: 'Lote Hilaza',
            field: 'LoteHilaza',
            className: 'small'
        },
        {
            header: 'Cliente Destino',
            field: 'ClienteDestino',
        },
        {
            header: 'Sales Order',
            field: 'SalesOrder',
        },
        {
            header: 'Comentario',
            field: 'Comentario',
        },
        
        {
            header: 'Agente',
            field: 'NombreCreador',
        },
        {
            header: 'Fecha Ventas',
            field: 'SolicitadoFecha',
            className: 'medium',
        },
        {
            header: 'Fecha Planing',
            field: 'GteFecha',
            className: 'medium',
        },
        {
            header: 'Fecha Logistica',
            field: 'LogFecha',
            className: 'medium',
        },
        {
            header: 'Fecha Finanzas',
            field: 'FinFecha',
            className: 'medium',
        },
        {
            header: 'Fecha G Planta',
            field: 'GGFecha',
            className: 'medium',
        },
        {
            header: 'Kgs',
            field: 'Kgs',
            Frozen: true,
            alignFrozen: 'right',
            className: 'Xsmall',
            Format: 'Currency'
        },
        {
            header: 'Ventas',
            field: 'VEN',
            Frozen: true,
            alignFrozen: 'right',
            className: 'Xsmall',
            Format: 'Checkbox',
            disabled: userAuth.AccesosWeb.includes('7'),
            onChange: (e, rowData) => changePermiso(e, rowData, 13)

            
        },
        {
            header: 'Planning',
            field: 'PLA',
            Frozen: true,
            alignFrozen: 'right',
            className: 'Xsmall',
            Format: 'Checkbox',
            disabled: userAuth.AccesosWeb.includes('8'),
            onChange: (e, rowData) => changePermiso(e, rowData, 14)

        },
        {
            header: 'Logistica',
            field: 'LOG',
            Frozen: true,
            alignFrozen: 'right',
            className: 'Xsmall',
            Format: 'Checkbox',
            disabled: userAuth.AccesosWeb.includes('9'),
            onChange: (e, rowData) => changePermiso(e, rowData, 15)

        },
        {
            header: 'Finanzas',
            field: 'FIN',
            Frozen: true,
            alignFrozen: 'right',
            className: 'Xsmall',
            Format: 'Checkbox',
            disabled: userAuth.AccesosWeb.includes('10'),
            onChange: (e, rowData) => changePermiso(e, rowData, 16)
        },
        {
            header: 'Gte General',
            field: 'GG',
            Frozen: true,
            alignFrozen: 'right',
            className: 'Xsmall',
            Format: 'Checkbox',
            disabled: userAuth.AccesosWeb.includes('11'),
            onChange: (e, rowData) => changePermiso(e, rowData, 17)
        },
        
        
    ]

    const table = {
        Columns: columns,
        Data: list,
        loading: loading,
        selected: select,
        setSelected: setSelect
    }

    useEffect(() => {
        getInfo()
    }, [])

    return (
        <div>
            <Card
                titulo={<div className='d-flex' style={{ gap: 5 }}>
                    <h3>Autorización de uso de Hilaza</h3>
                    <Toast ref={toast}/>
                    <CalendarWeek
                        date={dates}
                        setDate={setDates}
                        buscar={getInfo}
                        selectionMode='range'
                        loading={loading}
                    />
                </div>}
                contenido={<div style={{ height: '90vh' }} className='p-4'>
                    <AgGrid table={table}/>
                </div>}
            />
        </div>
    )
}

export default AutorizacionUsoHilazaScreen